export const MY_ACCOUNT_SEGMENTS: string[] = [
  'mijn-sunweb',
  'mit-sunweb',
  'mon-sunweb',
  'mitt-sunweb',
  'mein-sunweb',
  'mijn-eliza',
  'my',
]

export function isMyAccountPath(asPath: string): boolean {
  if (!asPath)
    return false
  const cleanPath = asPath.split('?')[0].split('#')[0]
  return cleanPath.split('/').some(segment => MY_ACCOUNT_SEGMENTS.includes(segment))
}
